import { render, staticRenderFns } from "./BaseResource.vue?vue&type=template&id=09b03183&"
import script from "./BaseResource.vue?vue&type=script&lang=js&"
export * from "./BaseResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports